module.exports = __webpack_public_path__ + "img/bosspack-badge.3288f668.svg";